import PropTypes from 'prop-types';
import Link from '@activebrands/core-web/components/Link';
import { OVERLAY_ID } from '@activebrands/core-web/config/overlay';
import overlay from '@activebrands/core-web/libs/overlay';
import { styled } from '@activebrands/core-web/libs/styletron';
import ThemeButton from 'components/buttons/ThemeButton';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';

const List = styled('ul', {
    display: ['none', null, null, null, null, 'flex'],
    flexDirection: 'row',
    gap: '4px',
    paddingLeft: ['0', null, null, null, null, '16px'],
    margin: '0',
});

const LevelOneItem = styled('li', {
    alignItems: 'center',
    display: 'flex',
    height: 'var(--height-header)',
    justifyContent: 'center',
    position: 'relative',
});

const PrimaryLevelOneDesktop = ({ items = [], menuValue = '', buttonColor, resetNavigation, setMenuValue }) => {
    if (!items?.length) {
        return null;
    }

    return (
        <List data-selector="global.nav.primary">
            {items.map(levelOneItem => {
                const hasSubmenu = levelOneItem.submenus?.length > 0;
                const isActive = menuValue.current === levelOneItem._uid;
                const sbEditable = transformPreviewEditable(levelOneItem._editable);

                // Only add isVolatile prop if there is a level one submenu that is a link
                // The reason to do this is because DOM doesn't recognize isVolatile if not a link
                const conditionalProps = {};
                if (!hasSubmenu) {
                    conditionalProps.isVolatile = true;
                }

                return (
                    <LevelOneItem $active={isActive} key={levelOneItem.label} {...sbEditable}>
                        <ThemeButton
                            isVolatile
                            data-selector="global.nav.link"
                            theme="link"
                            $style={{
                                padding: '4px 8px',
                                color: buttonColor,
                            }}
                            fontKeys={['Miscellaneous/14_100_500']}
                            as={hasSubmenu ? null : Link}
                            rel={levelOneItem?.follow === 'no_follow' ? 'nofollow' : undefined}
                            to={levelOneItem?.link?.url}
                            active={isActive}
                            aria-expanded={hasSubmenu ? isActive : undefined}
                            aria-haspopup={hasSubmenu ? 'menu' : undefined}
                            onClick={() => {
                                if (hasSubmenu) {
                                    overlay.closeAll();
                                    overlay.open(OVERLAY_ID.NAVIGATION);
                                    setMenuValue({
                                        current: hasSubmenu ? levelOneItem._uid : null,
                                        prev: menuValue.current,
                                    });
                                } else {
                                    resetNavigation();
                                }
                            }}
                            {...conditionalProps}
                        >
                            {levelOneItem.label}
                        </ThemeButton>
                    </LevelOneItem>
                );
            })}
        </List>
    );
};

PrimaryLevelOneDesktop.propTypes = {
    buttonColor: PropTypes.string,
    items: PropTypes.array.isRequired,
    menuValue: PropTypes.exact({
        current: PropTypes.string,
        prev: PropTypes.string,
    }).isRequired,
    resetNavigation: PropTypes.func,
    setMenuValue: PropTypes.func.isRequired,
};

export default PrimaryLevelOneDesktop;
